export default "__VITE_ASSET__C7YWRz4M__"